<template>
  <!-- cvc自愿认证 -->
  <div class="ApplicationFormFillIn">
    <div class="title">CVC自愿性认证</div>
    <!-- 搜索部分 -->
    <div class="header">
      <div space></div>
      <div>
        <el-radio-group v-model="formData.state">
          <el-radio :label="'0'">正常</el-radio>
          <el-radio :label="'1'">重要</el-radio>
          <el-radio :label="'2'">紧急</el-radio>
        </el-radio-group>
      </div>
    </div>

    <!-- 表单 -->
    <el-form
      :model="formData"
      label-width="190px"
      label-position="right"
      ref="formName"
      :rules="rules"
    >
      <div class="base_card">
        <div class="base_card_title">
          <i
            :class="{
              'el-icon-caret-bottom': hide1,
              'el-icon-caret-right': hide1 == false,
            }"
            @click="hideContent('1')"
          ></i>
          检测产品信息
        </div>
        <div v-show="hide1">
          <el-row align="bottom" justify="end">
            <el-col :offset="1" :span="10">
              <el-form-item label="产品名称：" prop="product_name">
                <el-input
                  class="myinput"
                  v-model="formData.product_name"
                ></el-input>
              </el-form-item>

              <el-form-item label="产品型号：" prop="product_model">
                <el-input
                  :autosize="{ minRows: 2 }"
                  class="myinput"
                  type="textarea"
                  v-model="formData.product_model"
                ></el-input>
              </el-form-item>
              <el-form-item label="保护级别：" prop="total_value">
                <el-input
                  class="myinput"
                  v-model="formData.product_protection_level"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col align="bottom" :offset="1" :span="10">
              <el-form-item label="商标：" prop="lab_area">
                <el-input
                  class="myinput"
                  v-model="formData.product_brand"
                ></el-input>
              </el-form-item>

              <el-form-item label="频率：" prop="sort">
                <el-input
                  class="myinput"
                  v-model="formData.product_frequency"
                ></el-input>
              </el-form-item>
              <el-form-item label="额定电压：" prop="sort">
                <el-input
                  class="myinput"
                  v-model="formData.product_rated_voltage"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="base_card testing">
        <div class="base_card_title flex justify-between align-center">
          <span>
            <i
              :class="{
                'el-icon-caret-bottom': hide2,
                'el-icon-caret-right': hide2 == false,
              }"
              @click="hideContent('2')"
            ></i>
            检测要求或说明</span
          >
        </div>
        <div v-show="hide2">
          <el-row class="row-bg">
            <div
              v-for="(item, idx) in formData.check_id"
              :key="idx"
              style="width: 100%; min-height: 300px"
            >
              <el-col :offset="1" :span="3">
                <el-form-item label="" prop="check_id.check_id" label-width="0">
                  <div>检测产品：</div>
                  <el-select
                    filterable
                    class="myinput"
                    v-model="item.productClass"
                    placeholder="请选择检测产品"
                    @change="getProductSelect(item.productClass)"
                  >
                    <el-option
                      v-for="(item, index) in testing_product_classify"
                      :key="index + 222"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :offset="0" :span="3" class="">
                <el-form-item
                  label=""
                  prop="check_id.check_id"
                  label-width="0"
                  style="overflow: hidden"
                  class=""
                >
                  <div class="padding_10">检测类别：</div>
                  <el-checkbox-group
                    v-model="item.detectionClassArr"
                    class="checkbox_group overflow_scroll_box border_x padding_10"
                    style=""
                    @change="getStandardSelect(item.detectionClassArr)"
                  >
                    <el-checkbox
                      v-for="item in detectionClassList"
                      :key="item.key"
                      :label="item.key"
                      :value="item.key"
                      >{{ item.value }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>

              <el-col :offset="0" :span="4" class="padding_10">
                <el-form-item label="" prop="check_id.check_id" label-width="0">
                  <div>检测标准：</div>
                  <el-checkbox-group
                    v-model="item.check_idArr"
                    class="checkbox_group overflow_scroll_box padding_10"
                    @change="getTestproject(item.check_idArr)"
                  >
                    <el-checkbox
                      v-for="item in standartList"
                      :key="item.key"
                      :label="item.key"
                      :value="item.key"
                      >{{ item.value }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>

              <el-col :offset="0" :span="6" class="padding_10">
                <el-form-item
                  label=""
                  prop="check_id.check_id"
                  label-width="0"
                  class=""
                >
                  <div
                    class="padding_10"
                    style="display: flex; justify-content: space-between"
                  >
                    <span>检测项目：</span>
                    <div
                      v-if="
                        standartList.length > 0 && testProjectList.length > 0
                      "
                    >
                      <el-checkbox @change="handleAll" v-model="allChecked"
                        >全选</el-checkbox
                      >
                    </div>
                  </div>
                  <el-checkbox-group
                    v-model="item.entrustment_Inspection_list"
                    class="checkbox_group overflow_scroll_box border_x padding_10"
                    @change="
                      entrustment_Inspection_listChange(
                        item.entrustment_Inspection_list,
                        item
                      )
                    "
                  >
                    <!-- // 3.4 -->
                    <el-checkbox
                      v-for="item in testProjectList"
                      :key="item.key"
                      :label="item.key"
                      :value="item.key"
                      @change="entrustment_Inspection_AloneChange(item)"
                      >{{ item.value }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>

              <el-col :offset="0" :span="6" class="padding_10">
                <el-form-item
                  label=""
                  prop="check_id.check_id"
                  label-width="0"
                  class="padding_10"
                >
                  <div>已选中检测项目：</div>
                  <div class="overflow_scroll_box">
                    <div
                      v-for="(item, index) in hasdetectionClassLists"
                      :key="index"
                    >
                      <span
                        >{{ item.product_title }}-{{ item.category_title }}-{{
                          item.standard_title
                        }}-</span
                      >
                      <span style="font-weight: 800; font-size: 15px">
                        {{ item.value }}</span
                      >
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <!-- 实验分室选择 -->
          <!-- <el-row class="row-bg" v-if="come == ''">
            <el-col :offset="1" :span="10">
              <el-form-item
                label="项目负责人："
                prop="check_project_leader_id_list"
              >
                <el-select
                  filterable
                  clearable
                  multiple
                  class="myinput"
                  v-model="formData.check_project_leader_id_list"
                  placeholder="请选择项目负责人"
                >
                  <el-option
                    v-for="(item, index) in select_list_obj.users"
                    :key="index"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="检测周期：" prop="check_end_time">
                <el-date-picker
                  class="el-date-picker timerSelect"
                  v-model="formData.time"
                  type="daterange"
                  range-separator="到"
                  start-placeholder=""
                  end-placeholder=""
                  value-format="yyyy-MM-dd"
                  @change="handleTime"
                >
                </el-date-picker>
                <span>
                  共<el-input
                    class="mini_ipt"
                    v-model="cup_check_cycle"
                    placeholder=""
                  ></el-input
                  >工作日
                </span>
              </el-form-item>
            </el-col>
            <el-col :offset="1" :span="10">
              <el-form-item label="实验分室：" prop="check_division_id_list">
                <el-select
                  filterable
                  clearable
                  class="myinput"
                  multiple
                  v-model="formData.check_division_id_list"
                  placeholder="请选择实验分室"
                >
                  <el-option
                    v-for="(item, index) in select_list_obj.division"
                    :key="index"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-bg" v-if="come == ''">
            <el-col :offset="1" :span="10">
              <el-form-item label="资质标识专用章:" prop="">
                <el-checkbox-group
                  v-model="formData.check_special_seal_list"
                  v-for="item in select_list_obj.specialSeal"
                  :key="item.key"
                  @change="specialSeal_change"
                >
                  <el-checkbox
                    :label="item.key"
                    :value="item.key"
                    style="float: left; margin-right: 15px"
                    >{{ item.value }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row> -->

          <el-row>
            <el-col :offset="1" :span="20">
              <el-form-item label="备注：" prop="check_remarks">
                <el-input
                  clearable
                  type="textarea"
                  :autosize="{ minRows: 3 }"
                  class="myinput"
                  v-model="formData.check_remarks"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 3.28 -->
          <el-row
            v-if="
              !(
                $route.query.come == 'applicationForm' &&
                $route.query.from == 'Offer'
              )
            "
          >
            <div class="padding">
              <!-- 报价费用（明细） -->
              <div class="btable">
                <div class="btable_title">报价费用（明细）</div>
                <div class="flex justify-around align-center">
                  <div>检测标准及要求</div>
                  <div>测试项目</div>
                  <div>原币金额</div>
                  <div>人民币金额</div>
                  <div>增值税（6%）</div>
                  <div @click="feeAdd" class="iconBox" style="width: 10%">
                    <i class="el-icon-circle-plus"></i>
                  </div>
                </div>

                <!-- 报价费用循环 -->
                <div
                  v-for="(item, idx) in formData.fee"
                  :key="idx"
                  class="flex justify-around align-center"
                >
                  <div>
                    <el-input
                      class="input show_border"
                      v-model="item.testing_id"
                      placeholder="请输入"
                    ></el-input>
                    <span @click="handleShow(idx)" class="chooseBtn">选择</span>
                  </div>
                  <div>
                    <el-input
                      class="input show_border"
                      v-model="item.item_name"
                      placeholder="请输入"
                    ></el-input>
                  </div>
                  <div>/</div>
                  <div>
                    <el-input
                      class="input show_border"
                      v-model="item.price"
                      placeholder="请输入"
                      type="number"
                    ></el-input>
                  </div>
                  <div>
                    <span class="" style="color: #333">{{
                      (item.price * 0.06).toFixed(2)
                    }}</span>
                  </div>
                  <div @click="feeDel(idx)" class="iconBox" style="width: 10%">
                    <i class="el-icon-remove"></i>
                  </div>
                </div>
                <div></div>
                <div class="btable_title">增加费用（明细）</div>
                <div class="flex justify-between align-center">
                  <div>增项标准</div>
                  <div>增项名称</div>
                  <div>增项费用</div>
                  <div @click="otherAdd">
                    <i class="el-icon-circle-plus" style="width: 10%"></i>
                  </div>
                </div>
                <!-- 增加费用（明细）循环 -->
                <div
                  v-for="(item, index) in formData.other"
                  :key="index + 111"
                  class="flex justify-around align-center"
                >
                  <div>
                    <el-input
                      class="input show_border"
                      v-model="item.testing_name"
                      placeholder="请输入"
                    ></el-input>
                  </div>
                  <div style="">
                    <el-input
                      class="input show_border"
                      v-model="item.item_name"
                      placeholder="请输入"
                    ></el-input>
                  </div>
                  <div>
                    <el-input
                      class="input show_border"
                      v-model="item.price"
                      placeholder="请输入"
                      type="number"
                    ></el-input>
                  </div>
                  <div @click="otherDel(index)">
                    <i class="el-icon-remove" style="width: 10%"></i>
                  </div>
                </div>
                <div class="flex justify-around align-center">
                  <div>合计金额</div>
                  <div></div>
                  <div>{{ com_price }}</div>
                  <div></div>
                </div>
              </div>
            </div>
          </el-row>
        </div>
      </div>

      <div class="base_card">
        <div class="base_card_title">
          <i
            :class="{
              'el-icon-caret-bottom': hide3,
              'el-icon-caret-right': hide3 == false,
            }"
            @click="hideContent('3')"
          ></i
          >企业信息
        </div>
        <div v-show="hide3">
          <el-row class="row-bg">
            <!-- <el-col :span="1" class="text-f5">.</el-col> -->
            <el-col :offset="1" :span="23">
              <!-- 委托单位 -->
              <div class="fill_item">
                <el-form-item
                  label="委托单位名称："
                  prop="enterprise_client_name"
                >
                  <el-input
                    clearable
                    class="input"
                    placeholder="请选择已有企业或输入后选择"
                    v-model="formData.enterprise_client_name"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item
                  label="委托单位名称："
                  prop="enterprise_client_name"
                >
                  <el-select
                    filterable
                    class="myinput"
                    allow-create
                    clearable
                    default-first-option
                    v-model="formData.enterprise_client_name"
                    placeholder="请选择已有企业或输入后选择"
                    @change="
                      handleEnterprise($event, '1', 'enterprise_', 'client')
                    "
                  >
                    <el-option
                      v-for="(item, index) in enterprise_select"
                      :key="index + 222"
                      :label="item.enterprise_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item
                  label="委托单位地址："
                  prop="enterprise_client_province"
                >
                  <el-input
                    clearable
                    class="input"
                    v-model="formData.enterprise_client_address"
                  ></el-input>
                </el-form-item>

                <el-row style="width: 100%">
                  <el-col :offset="0" :span="5">
                    <el-form-item
                      label="联系人: "
                      prop="enterprise_client_contacts"
                    >
                      <el-input
                        clearable
                        v-model="formData.enterprise_client_contacts"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="联系电话:" prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_client_phone"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="座机电话:" prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_client_tel"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="邮箱:" prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_client_email"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!-- 生产者 -->
              <div class="fill_item">
                <el-form-item
                  label="生产者名称："
                  prop="enterprise_manufacturer_name"
                >
                  <el-select
                    filterable
                    class="myinput"
                    allow-create
                    clearable
                    default-first-option
                    v-model="formData.enterprise_manufacturer_name"
                    placeholder="请选择企业"
                    @change="
                      handleEnterprise(
                        $event,
                        '2',
                        'enterprise_',
                        'manufacturer'
                      )
                    "
                  >
                    <el-option
                      v-for="(item, index) in enterprise_select"
                      :key="index + 222"
                      :label="item.enterprise_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-button
                    @click="ditto('manufacturer', 2, '1')"
                    type="primary"
                    size="small"
                    >同上</el-button
                  >
                </el-form-item>
                <el-form-item
                  label="生产者地址："
                  prop="enterprise_manufacturer_province"
                >
                  <el-input
                    clearable
                    class="input"
                    v-model="formData.enterprise_manufacturer_address"
                  ></el-input>
                </el-form-item>

                <el-row>
                  <el-col :offset="0" :span="5">
                    <el-form-item
                      label="联系人: "
                      prop="enterprise_manufacturer_contacts"
                    >
                      <el-input
                        clearable
                        v-model="formData.enterprise_manufacturer_contacts"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="联系电话:" prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_manufacturer_phone"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="座机电话:" prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_manufacturer_tel"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="邮箱:" prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_manufacturer_email"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!-- 生产企业 -->
              <div class="fill_item">
                <el-form-item
                  label="生产企业名称："
                  prop="enterprise_make_name"
                >
                  <el-select
                    filterable
                    class="myinput"
                    allow-create
                    clearable
                    default-first-option
                    v-model="formData.enterprise_make_name"
                    placeholder="请选择企业"
                    @change="
                      handleEnterprise($event, '3', 'enterprise_', 'make')
                    "
                  >
                    <el-option
                      v-for="(item, index) in enterprise_select"
                      :key="index + 222"
                      :label="item.enterprise_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-button
                    @click="ditto('make', 3, '1')"
                    type="primary"
                    size="small"
                    >同上</el-button
                  >
                </el-form-item>
                <el-form-item
                  label="生产企业地址："
                  prop="enterprise_make_province"
                >
                  <el-input
                    clearable
                    class="input"
                    v-model="formData.enterprise_make_address"
                  ></el-input>
                </el-form-item>

                <el-row style="width: 100%">
                  <el-col :offset="0" :span="5">
                    <el-form-item
                      label="联系人: "
                      prop="enterprise_make_contacts"
                    >
                      <el-input
                        clearable
                        v-model="formData.enterprise_make_contacts"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="联系电话:" prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_make_phone"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="座机电话:" prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_make_tel"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="邮箱:" prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_make_email"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 代理商 -->
              <div class="fill_item">
                <el-form-item label="代理商名称：" prop="">
                  <el-select
                    filterable
                    class="myinput"
                    allow-create
                    clearable
                    default-first-option
                    v-model="formData.enterprise_agent_name"
                    placeholder="请选择企业"
                    @change="
                      handleEnterprise($event, '4', 'enterprise_', 'agent')
                    "
                  >
                    <el-option
                      v-for="(item, index) in enterprise_select"
                      :key="index + 222"
                      :label="item.enterprise_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-button
                    @click="ditto('agent', 4, '1')"
                    type="primary"
                    size="small"
                    >同上</el-button
                  >
                </el-form-item>
                <el-form-item label="代理商地址：" prop="">
                  <el-input
                    clearable
                    class="input"
                    v-model="formData.enterprise_agent_address"
                  ></el-input>
                </el-form-item>
                <!-- 联系电话、联系人 -->

                <el-row style="width: 100%">
                  <el-col :offset="0" :span="5">
                    <el-form-item label="联系人: " prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_agent_contacts"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="联系电话:" prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_agent_phone"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="座机电话:" prop="">
                      <el-input
                        clearable
                        v-model="formData.enterprise_agent_tel"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="bottom" :offset="0" :span="6">
                    <el-form-item label="邮箱:" prop="enterprise_agent_email">
                      <el-input
                        clearable
                        v-model="formData.enterprise_agent_email"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="base_card">
        <div class="base_card_title">
          <i
            :class="{
              'el-icon-caret-bottom': hide4,
              'el-icon-caret-right': hide4 == false,
            }"
            @click="hideContent('4')"
          ></i
          >其他企业信息
        </div>
        <div v-show="hide4">
          <el-row class="row-bg">
            <!-- <el-col :span="1" class="text-f5">.</el-col> -->
            <el-col :offset="1" :span="23">
              <div class="fill_item">
                <el-form-item
                  label="缴费单位："
                  prop="oenterprise_pay_name"
                >
                  <el-input
                    clearable
                    class="input"
                    placeholder="请选择企业"
                    v-model="formData.oenterprise_pay_name"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="缴费单位：" prop="oenterprise_pay_name">
                  <el-select
                    filterable
                    class="myinput"
                    allow-create
                    clearable
                    default-first-option
                    v-model="formData.oenterprise_pay_name"
                    placeholder="请选择企业"
                    @change="
                      handleEnterprise($event, '5', 'oenterprise_', 'pay')
                    "
                  >
                    <el-option
                      v-for="(item, index) in enterprise_select"
                      :key="index + 222"
                      :label="item.enterprise_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item
                  label="缴费地址："
                  prop="oenterprise_pay_province"
                >
                  <el-input
                    clearable
                    class="input"
                    v-model="formData.oenterprise_pay_address"
                  ></el-input>
                </el-form-item>
                <!-- 联系电话、联系人 -->
                <div class="flex justify-start contacts" style="">
                  <el-row style="width: 100%">
                    <el-col :offset="0" :span="5">
                      <el-form-item
                        label="联系人: "
                        prop="oenterprise_pay_contacts"
                      >
                        <el-input
                          clearable
                          v-model="formData.oenterprise_pay_contacts"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col align="bottom" :offset="0" :span="6">
                      <el-form-item label="联系电话:" prop="">
                        <el-input
                          clearable
                          v-model="formData.oenterprise_pay_phone"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col align="bottom" :offset="0" :span="6">
                      <el-form-item label="座机电话:" prop="">
                        <el-input
                          clearable
                          v-model="formData.oenterprise_pay_tel"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col align="bottom" :offset="0" :span="6">
                      <el-form-item label="邮箱:" prop="">
                        <el-input
                          clearable
                          v-model="formData.oenterprise_pay_email"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="fill_item">
                <el-form-item
                  label="发票接收单位："
                  prop="oenterprise_invoice_name"
                >
                  <el-select
                    filterable
                    class="myinput"
                    allow-create
                    clearable
                    default-first-option
                    v-model="formData.oenterprise_invoice_name"
                    placeholder="请选择企业"
                    @change="
                      handleEnterprise($event, '6', 'oenterprise_', 'invoice')
                    "
                  >
                    <el-option
                      v-for="(item, index) in enterprise_select"
                      :key="index + 222"
                      :label="item.enterprise_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-button
                    @click="ditto('invoice', 6, '5')"
                    type="primary"
                    size="small"
                    >同上</el-button
                  >
                </el-form-item>
                <el-form-item
                  label="发票接收单位地址："
                  prop="oenterprise_invoice_province"
                >
                  <el-input
                    clearable
                    class="input"
                    v-model="formData.oenterprise_invoice_address"
                  ></el-input>
                </el-form-item>
                <!-- 联系电话、联系人 -->
                <div class="flex justify-start contacts" style="">
                  <el-row style="width: 100%">
                    <el-col :offset="0" :span="5">
                      <el-form-item
                        label="联系人: "
                        prop="oenterprise_invoice_contacts"
                      >
                        <el-input
                          clearable
                          v-model="formData.oenterprise_invoice_contacts"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col align="bottom" :offset="0" :span="6">
                      <el-form-item label="联系电话:" prop="">
                        <el-input
                          clearable
                          v-model="formData.oenterprise_invoice_phone"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col align="bottom" :offset="0" :span="6">
                      <el-form-item label="座机电话:" prop="">
                        <el-input
                          clearable
                          v-model="formData.oenterprise_invoice_tel"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col align="bottom" :offset="0" :span="6">
                      <el-form-item label="邮箱:" prop="">
                        <el-input
                          clearable
                          v-model="formData.oenterprise_invoice_email"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div class="fill_item">
                <el-form-item
                  label="报告、证书收件公司："
                  prop="oenterprise_receiving_name"
                >
                  <el-select
                    filterable
                    class="myinput"
                    allow-create
                    clearable
                    default-first-option
                    v-model="formData.oenterprise_receiving_name"
                    placeholder="请选择企业"
                    @change="
                      handleEnterprise($event, '7', 'oenterprise_', 'receiving')
                    "
                  >
                    <el-option
                      v-for="(item, index) in enterprise_select"
                      :key="index + 222"
                      :label="item.enterprise_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-button
                    @click="ditto('receiving', 7, '5')"
                    type="primary"
                    size="small"
                    >同上</el-button
                  >
                </el-form-item>
                <el-form-item
                  label="报告、证书收件公司地址："
                  prop="oenterprise_receiving_province"
                >
                  <el-input
                    clearable
                    class="input"
                    v-model="formData.oenterprise_receiving_address"
                  ></el-input>
                </el-form-item>
                <!-- 联系电话、联系人 -->
                <div class="flex justify-start contacts" style="">
                  <el-row style="width: 100%">
                    <el-col :offset="0" :span="5">
                      <el-form-item
                        label="联系人: "
                        prop="oenterprise_receiving_contacts"
                      >
                        <el-input
                          clearable
                          v-model="formData.oenterprise_receiving_contacts"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col align="bottom" :offset="0" :span="6">
                      <el-form-item label="联系电话:" prop="">
                        <el-input
                          clearable
                          v-model="formData.oenterprise_receiving_phone"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col align="bottom" :offset="0" :span="6">
                      <el-form-item label="座机电话:" prop="">
                        <el-input
                          clearable
                          v-model="formData.oenterprise_receiving_tel"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col align="bottom" :offset="0" :span="6">
                      <el-form-item label="邮箱:" prop="">
                        <el-input
                          clearable
                          v-model="formData.oenterprise_receiving_email"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>

                <el-form-item
                  label="是否需要证书："
                  prop="oenterprise_is_certificate"
                >
                  <!-- certificate -->
                  <el-radio-group v-model="formData.oenterprise_is_certificate">
                    <el-radio
                      v-for="(item, index) in select_list_obj.certificate"
                      :key="index"
                      :label="item.key"
                      >{{ item.value }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>

                <!-- <el-form-item label="是否创建样品：" prop="sample_type">
                  <el-radio-group v-model="formData.sample_type">
                    <el-radio label="1">创建</el-radio>
                    <el-radio label="0">不创建</el-radio>
                  </el-radio-group>
                </el-form-item> -->

                <el-form-item label="报告/证书制作形式：" prop="checkboxvalue">
                  <div class="flex">
                    <el-checkbox-group
                      v-for="item in select_list_obj.makeForm"
                      :key="item.key"
                      v-model="formData.checkboxvalue"
                      @change="checkbox_change"
                    >
                      <el-checkbox
                        :label="item.key"
                        :value="item.key"
                        style="float: left; margin-right: 15px"
                        >{{ item.value }}</el-checkbox
                      >
                    </el-checkbox-group>

                    <span class="text-red margin-left-sm"
                      >备注说明：电子版和纸质版取其一，一般默认电子版；如同时需要电子版和纸质版需加收200元。</span
                    >
                  </div>
                </el-form-item>
                <el-form-item
                  label="报告/证书交付方式："
                  prop="oenterprise_deliver"
                >
                  <el-radio-group v-model="formData.oenterprise_deliver">
                    <el-radio
                      v-for="(item, index) in select_list_obj.makeFormPay"
                      :key="index"
                      :label="item.key"
                      >{{ item.value }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="样品处置方式："
                  prop="oenterprise_disposal_pattern"
                >
                  <el-radio-group
                    v-model="formData.oenterprise_disposal_pattern"
                  >
                    <el-radio
                      v-for="(item, index) in select_list_obj.disposalPattern"
                      :key="index"
                      :label="item.key"
                      >{{ item.value }}</el-radio
                    >
                  </el-radio-group>
                  <span class="text-red margin-left-sm"
                    >注：未及时取回样品又无说明者由威诺销毁。</span
                  >
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <div class="tips1">
            <span style="color: 62b3ff">说明：</span> 价格确认函
            (附件)/或收费通知作为本合同书的一部分。客户必须对样品及其相关信息的真实性负责。履行本合同书的始期为样品、技术资料、检测费用的最后收到时间。必要时我们会通知您补送有关样品、资料，试验时间顺延。
          </div>
          <div class="tips1">
            <span style="color: 62b3ff">承诺：</span>
            对于检测过程中了解到客户的有关情况及客户非公开性的资料我们将予以保密。
          </div>
        </div>
      </div>

      <div class="base_card">
        <div class="base_card_title">
          <i
            :class="{
              'el-icon-caret-bottom': hide5,
              'el-icon-caret-right': hide5 == false,
            }"
            @click="hideContent('5')"
          ></i
          >相关附件
        </div>

        <div v-show="hide5">
          <el-row class="row-bg" style="padding-bottom: 100px">
            <el-col :offset="1" :span="23">
              <el-form-item label="其它资料：" prop="user_id">
                <label for="annex_others">
                  <div
                    class="cursor add_attachment"
                    @click="uploadApplication()"
                  >
                    添加附件+
                  </div>
                </label>
                <!-- 文件回显 -->
                <div class="filefooter">
                  <div class="image">
                    <div
                      v-for="(item, i) in formData.uploadTableData"
                      :key="i"
                      class="image_pdf"
                    >
                      <div class="image_pdf_top">
                        <img
                          src="../../assets/pdf_image.png"
                          alt=""
                          v-if="item.fileType == 'pdf'"
                        />
                        <img src="../../assets/doc_image.png" alt="" v-else />
                        <div class="box" v-if="item.fileType == 'pdf'">
                          <div>
                            <i class="el-icon-view" @click="preview(item)"></i>
                          </div>
                          <div>
                            <i
                              class="el-icon-download"
                              @click="downloadPdf(item)"
                            ></i>
                          </div>
                        </div>
                        <div class="box" v-else>
                          <div>
                            <i class="el-icon-view" @click="preview(item)"></i>
                          </div>
                          <!-- 下载word -->
                          <a :href="item.url" target="_blank">
                            <i class="el-icon-download"></i>
                          </a>
                        </div>
                      </div>
                      <div class="text">{{ item.upload_name }}</div>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <div class="flex justify-center align-center">
      <el-button
        class="bottom_btn cursor"
        :loading="loading"
        @click="submit('formName')"
        >提 交</el-button
      >
    </div>

    <!-- 添加附件 其他资料 -->
    <el-dialog
      title="上传"
      :visible.sync="uploadShow"
      width="800px"
      :before-close="handleClose"
      center
    >
      <el-upload
        style="width: 100%"
        class="upload-demo"
        drag
        action="111"
        multiple
        :show-file-list="false"
        accept=".doc,.docx,.pdf"
        :http-request="beforeUpload"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <el-table
        :data="formData.uploadTableData"
        style="width: 100%"
        border
        :header-cell-style="{
          background: '#DAD9D9',
          color: '#333333',
          'border-color': '#999999',
        }"
        :cell-style="{ 'border-color': '#ccc' }"
        class="source_table"
      >
        <el-table-column
          label="文件名"
          prop="upload_name"
          align="center"
        ></el-table-column>
        <el-table-column
          label="大小"
          prop="size"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span class="text-blue" @click="deleteFile(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="uploadShow = false">取 消</el-button> -->
        <el-button type="primary" @click="uploadShow = false">确 定</el-button>
      </span>
    </el-dialog>
    <EnterpriseLibrary
      v-if="isEnterpriseLibrary"
      title="企业库"
      @hide="hide"
    ></EnterpriseLibrary>
    <testing
      v-if="isTesting"
      title="费用选择"
      :check_id="formData.check_id"
      @hide_price="hide_price"
      @hide_close="hide_close"
    ></testing>
  </div>
</template>

<script>
import EnterpriseLibrary from "./components/EnterpriseLibrary";
import testing from "@/components/testing.vue";
import {
  httpEnterpriseList,
  httpCommonSelect,
  httpArea,
  httpApplyformSelect,
  httpClassifySelect,
  httpReviewerSelect,
  httpTextPro,
  httpUpload,
  httpUploadDe,
  httpDownload,
  httpUploads,
  httpFormAdd,
  httpDetails,
} from "../../utils/housecvc";
export default {
  components: {
    EnterpriseLibrary,
    testing,
  },
  computed: {
    // 3.28
    com_price() {
      let price = 0,
        l_price = 0;
      if (!this.$tools.isEmpty(this.formData.fee)) {
        this.formData.fee.map((ite, idx) => {
          l_price = Number(ite.price) + Number(ite.price) * 0.06;
          price = price + l_price;
        });
      }
      if (!this.$tools.isEmpty(this.formData.other)) {
        this.formData.other.map((ite, idx) => {
          price = price + Number(ite.price);
        });
      }
      return price.toFixed(2);
    },
    // cup_check_cycle() {
    //   let first, last;
    //   first = this.$tools.strToDate(
    //     this.formData.check_start_time
    //       ? this.formData.check_start_time
    //       : "2020-11-11"
    //   );
    //   last = this.$tools.strToDate(
    //     this.formData.check_end_time
    //       ? this.formData.check_end_time
    //       : "2020-11-10"
    //   );
    //   return this.$tools.getWeekday(first, last);
    // },
  },
  data() {
    return {
      uploadShow: false, //上传弹窗
      // uploadTableData: [], //上传返回的表格数据
      // filetype: "",

      // 11.12 新
      allChecked: false, //项目全选
      propObj3: {},
      propObj2: {},
      propObj1: {},

      countersign: "", //会签人
      come: "",
      hide1: true, //卡片内容隐藏
      hide2: true, //检测要求或说明
      hide3: true, //
      hide4: true, //卡片内容隐藏
      hide5: true, //卡片内容隐藏
      hide6: true, //卡片内容隐藏
      hide7: true, //需确认接触食品特性信息
      hide8: true, //与食品接触部件材料清单
      hide9: true, //与食品接触部件材料清单
      add_idx: 0,
      str: "",
      loading: false,
      select: {},
      selectList: [],
      // 3.28
      isTesting: false,
      testing_list: [],
      project_list: {},
      formData: {
        // 304
        fee: [
          //报价费用明细
          {
            testing_id: "",
            testing_name: "",
            item_id: "",
            item_name: "",
            price: "",
            // 3.28
            id: "",
          },
        ],
        other: [
          {
            testing_name: "",
            item_name: "",
            price: "",
          },
        ],
        testing_list: [],
        project_list: {},
        uploadTableData: [], //上传的文件

        state: "0",
        check_special_seal: "", //资质标识专用章
        check_special_seal_list: [], //资质标识专用章
        check_remarks: "", //备注
        audit_cc_uid: "",
        join_cc_uid: "",
        join_cc_uid_list: [],
        audit_uid: "",
        audit_uid_list: [], //审核人
        join_uid: "",
        join_uid_list: [], //会签人
        apply_number_prefix: "",
        project_number_prefix: "",
        apply_number_value: "",
        project_number: "",
        sample_number: "",
        business_type: "",
        // other: "",
        remarks: "",
        product_name: "",
        product_large_class: "",
        product_small_class: "",
        letter_class_arr: [], //产品小类
        large_class_arr: [], //产品大类
        product_model: "",
        product_brand: "",
        product_protection_level: "",
        product_dampproof: "",
        product_rated_voltage: "",
        product_power_connection: "",
        product_current_power: "",
        product_frequency: "",
        check_name: "",
        check_project_leader_id: "",
        check_project_leader_name: "",
        check_division_id: "",
        check_division_id_list: [],
        check_division_name: "",
        check_user_id: "",
        check_user_id_list: [],
        check_project_leader_id_list: [], //项目负责人
        check_project_leader_name_list: [], //项目负责人名字
        check_user_name: "",
        check_start_time: "",
        check_end_time: "",
        check_cycle: "",

        enterprise_client_id: "",
        enterprise_client_name: "",
        enterprise_client_province: "",
        enterprise_client_city: "",
        enterprise_client_address: "",
        enterprise_client_phone: "",
        enterprise_client_tel: "",
        enterprise_client_contacts: "",
        enterprise_client_postcode: "",
        enterprise_client_code: "",
        enterprise_client_email: "",

        enterprise_manufacturer_id: "",
        enterprise_manufacturer_name: "",
        enterprise_manufacturer_province: "",
        enterprise_manufacturer_city: "",
        enterprise_manufacturer_address: "",
        enterprise_manufacturer_phone: "",
        enterprise_manufacturer_tel: "",
        enterprise_manufacturer_contacts: "",
        enterprise_manufacturer_postcode: "",
        enterprise_manufacturer_code: "",
        enterprise_manufacturer_email: "",

        enterprise_make_id: "",
        enterprise_make_name: "",
        enterprise_make_province: "",
        enterprise_make_city: "",
        enterprise_make_address: "",
        enterprise_make_phone: "",
        enterprise_make_tel: "",
        enterprise_make_contacts: "",
        enterprise_make_postcode: "",
        enterprise_make_code: "",
        enterprise_make_email: "",

        enterprise_agent_id: "",
        enterprise_agent_name: "",
        enterprise_agent_province: "",
        enterprise_agent_city: "",
        enterprise_agent_address: "",
        enterprise_agent_phone: "",
        enterprise_agent_tel: "",
        enterprise_agent_contacts: "",
        enterprise_agent_postcode: "",
        enterprise_agent_code: "",
        enterprise_agent_email: "",

        oenterprise_pay_id: "",
        oenterprise_pay_name: "",
        oenterprise_pay_province: "",
        oenterprise_pay_city: "",
        oenterprise_pay_address: "",
        oenterprise_pay_phone: "",
        oenterprise_pay_tel: "",
        oenterprise_pay_contacts: "",
        oenterprise_pay_postcode: "",
        oenterprise_pay_code: "",
        oenterprise_pay_email: "",

        oenterprise_invoice_id: "",
        oenterprise_invoice_name: "",
        oenterprise_invoice_province: "",
        oenterprise_invoice_city: "",
        oenterprise_invoice_address: "",
        oenterprise_invoice_phone: "",
        oenterprise_invoice_tel: "",
        oenterprise_invoice_contacts: "",
        oenterprise_invoice_postcode: "",
        oenterprise_invoice_code: "",
        oenterprise_invoice_email: "",

        oenterprise_receiving_id: "",
        oenterprise_receiving_name: "",
        oenterprise_receiving_province: "",
        oenterprise_receiving_city: "",
        oenterprise_receiving_address: "",
        oenterprise_receiving_phone: "",
        oenterprise_receiving_tel: "",
        oenterprise_receiving_contacts: "",
        oenterprise_receiving_postcode: "",
        oenterprise_receiving_code: "",
        oenterprise_receiving_email: "",

        oenterprise_is_certificate: "",
        oenterprise_make_form: "", //报告制作形式穿给后端
        oenterprise_deliver: "",
        oenterprise_disposal_pattern: "",
        annex_commission_contract: "",
        annex_spare_parts: "",
        annex_others: "",
        when: "",
        entrust_time: "",
        qwer: "",
        checkboxvalue: [], //报告制作形式数组
        time: [],
        sample_type: 0,

        // 11.12
        check_id_lists: [],
        check_id: [
          {
            check_id: "", //检测标准
            entrustment_Inspection: "", //检测项目处理后格式  字符串且逗号隔开
            entrustment_Inspection_list: [], //检测项目处理前格式
            project_list_item: [],

            productClass: "", //检测产品分类
            detectionClass: "", //检测分类
            detectionClassArr: [],
            check_idArr: [], //检测标准
          },
        ],

        // testing_list: [],
        // project_list: {},
      },

      testing_product_classify: [], //检测仙品下拉数据
      detectionClassList: [], //检测分类下拉数据
      standartList: [], //检测标准下拉数据
      testProjectList: [], //检测项目下拉数据

      testproject: {}, //检测项目返回的原本数据
      testStandard: {}, //检测标准返回的原本数据
      // 11.12
      hasdetectionClassLists: [],
      hasdetectionClassList: [], //已选择的产品分类
      hastestProjectList: [], //已选择的检测项目
      hastestProjectValue: [], //已选择的检测项目

      search: "",
      rules: {
        product_model: [
          { required: true, message: "产品型号", trigger: "blur" },
        ],

        check_end_time: [
          { required: true, message: "请填写检测周期", trigger: "blur" },
        ],
        // 企业信息验证
        enterprise_manufacturer_name: [
          { required: true, message: "生产者名称", trigger: "blur" },
        ],

        enterprise_manufacturer_email: [
          {
            required: true,
            message: "请填写生产者邮箱",
            trigger: "blur",
          },
          {
            pattern:
              /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            message: "请填写正确的邮箱",
            trigger: "blur",
          },
        ],
        enterprise_make_name: [
          { required: true, message: "生产企业名称", trigger: "blur" },
        ],

        enterprise_make_email: [
          {
            required: true,
            message: "请填写生产企业邮箱",
            trigger: "blur",
          },
          {
            pattern:
              /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            message: "请填写正确的邮箱",
            trigger: "blur",
          },
        ],
        enterprise_agent_name: [
          { required: true, message: "代理商名称", trigger: "blur" },
        ],

        oenterprise_receiving_name: [
          { required: true, message: "报告、证书收件公司", trigger: "blur" },
        ],

        oenterprise_receiving_email: [
          {
            required: true,
            message: "请填写邮箱",
            trigger: "blur",
          },
          {
            pattern:
              /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            message: "请填写正确的邮箱",
            trigger: "blur",
          },
        ],

        enterprise_client_name: [
          { required: true, message: "委托单位名称", trigger: "blur" },
        ],

        enterprise_client_contacts: [
          {
            required: true,
            message: "请填写联系人",
            trigger: "blur",
          },
        ],
        enterprise_client_phone: [
          {
            required: true,
            message: "请填写手机号码",
            trigger: "blur",
          },
          { pattern: /^1[3456789]\d{9}$/, message: "请填写正确的手机号码" },
        ],
        enterprise_client_email: [
          {
            required: true,
            message: "请填写邮箱",
            trigger: "blur",
          },
          {
            pattern:
              /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            message: "请填写正确的邮箱",
            trigger: "blur",
          },
        ],
        oenterprise_pay_name: [
          { required: true, message: "缴费单位", trigger: "blur" },
        ],

        oenterprise_pay_email: [
          {
            required: true,
            message: "请填写邮箱",
            trigger: "blur",
          },
          {
            pattern:
              /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            message: "请填写正确的邮箱",
            trigger: "blur",
          },
        ],
        oenterprise_invoice_name: [
          { required: true, message: "发票接收单位", trigger: "blur" },
        ],

        oenterprise_invoice_email: [
          {
            required: true,
            message: "请填写邮箱",
            trigger: "blur",
          },
          {
            pattern:
              /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            message: "请填写正确的邮箱",
            trigger: "blur",
          },
        ],

        // sample_type: [
        //   { required: true, message: "是否创建样品", trigger: "blur" },
        // ],
        oenterprise_is_certificate: [
          { required: true, message: "是否需要证书", trigger: "blur" },
        ],

        product_name: [
          { required: true, message: "产品名称", trigger: "blur" },
        ],

        checkboxvalue: [
          { required: true, message: "报告/证书制作形式", trigger: "blur" },
        ],
        oenterprise_disposal_pattern: [
          { required: true, message: "样品处置方式", trigger: "blur" },
        ],
        oenterprise_deliver: [
          { required: true, message: "报告/证书交付方式", trigger: "blur" },
        ],
        check_project_leader_id_list: [
          { required: true, message: "请选择项目负责人", trigger: "change" },
        ],
        check_division_id_list: [
          { required: true, message: "请选择实验分室", trigger: "change" },
        ],
        audit_uid_list: [
          { required: true, message: "请选择审核人", trigger: "blur" },
        ],
        join_uid_list: [
          { required: true, message: "请选择会签人", trigger: "blur" },
        ],
      },
      radio: "1",
      checkList: [],
      isEnterpriseLibrary: false,
      select_list_obj: {
        //下拉列表对象盒子
        large_class: [], //大类数组
        letter_class: [], //小类数组
        province_list: [], //省
        city_list_1: [], //区
        city_list_2: [], //区
        city_list_3: [], //区
        city_list_4: [], //区
        city_list_5: [], //区
        city_list_6: [], //区
        city_list_7: [], //区
        pid: "", //大类选择后的id
        division: [], //实验分室
        testing: [],
        testing_project: [],
      },
      enterprise_id: "", //企业库的选择id
      enterprise_key: "",
      enterprise_type: "",
      enterprise_val: "",
      userList: [], //人员名单

      enterprise_select: [],
      names: {},

      // 3.4
      product_title: "",
      category_title: "",
      standard_title: "",
    };
  },
  watch: {
    async hasdetectionClassLists() {
      // if(this.hasdetectionClassLists.length)
      let id_list = [],
        id_list_del = [];
      this.formData.fee.map(async (ite, idx) => {
        id_list.push(ite.item_id);
      });
      for (let index = 0; index < this.hasdetectionClassLists.length; index++) {
        const item = this.hasdetectionClassLists[index];
        // 添加
        if (id_list.indexOf(item.key) == -1) {
          if (this.formData.fee.length == 1 && !this.formData.fee[0].item_id) {
            this.formData.fee = [];
            this.formData.fee.push({
              testing_id: item.standard_title, //检测标准id
              item_id: item.key, //
              price: item.price, //金额
              item_name: item.value,
              testing_name: "",
              isPush: true,
            });
          } else {
            this.formData.fee.push({
              testing_id: item.standard_title, //检测标准id
              item_id: item.key, //
              price: item.price, //金额
              item_name: item.value,
              testing_name: "",
              isPush: true,
            });
          }
          // await this.getTestAndProject(item);
        }
      }

      // 删除
      if (this.$tools.isEmpty(this.hasdetectionClassLists)) {
        for (let index = 0; index < this.formData.fee.length; index++) {
          const item = this.formData.fee[index];
          // if (item.hasOwnProperty("isPush")) {
          //   // console.log('-------------------DEL',item,index);
          //   this.formData.fee.splice(index, 1);

          //   index = 0;
          // }
        }
      } else {
        this.hasdetectionClassLists.map(async (ite, idx) => {
          id_list_del.push(ite.key);
        });
        this.formData.fee.map((item, index) => {
          // if (
          //   id_list_del.indexOf(item.item_id) == -1 &&
          //   item.hasOwnProperty("isPush")
          // ) {
          //   this.formData.fee.splice(index, 1);
          // }
        });
      }
    },
  },
  methods: {
    // 选择报价费
    handleShow(idx) {
      // 9.10修改整合
      // console.log("index-------------------------------------------", idx);
      this.idx = idx;
      this.isTesting = true;
    },
    // 选择
    async hide_price({ query }) {
      this.isTesting = false;
      if (!this.$tools.isEmpty(query)) {
        // this.hasdetectionClassLists = [...this.hasdetectionClassLists,...query]

        query.map((item, index) => {
          if (this.formData.fee.length == 1 && !this.formData.fee[0].item_id) {
            this.formData.fee = [];
            this.formData.fee.push({
              testing_id: item.standard_title, //检测标准id
              item_id: item.key, //
              price: item.price, //金额
              item_name: item.value,
              testing_name: "",
            });
          } else {
            this.formData.fee.push({
              testing_id: item.standard_title, //检测标准id
              item_id: item.key, //
              price: item.price, //金额
              item_name: item.value,
              testing_name: "",
            });
          }
        });
      }
    },
    hide_close() {
      this.isTesting = false;
    },
    feeAdd() {
      this.formData.fee.push({
        testing_name: "",
        item_name: "",
        price: "",
      });
    },
    feeDel(i) {
      // 删除报价费用数据
      this.formData.fee.splice(i, 1);
      // 删除对应下拉
    },
    otherAdd() {
      this.formData.other.push({
        testing_name: "",
        item_name: "",
        price: "",
        id: "",
      });
    },
    otherDel(i) {
      this.formData.other.splice(i, 1);
    },
    //检测报告上传
    beforeUpload(files) {
      const fd = new FormData();
      fd.append("file", files.file);
      fd.append("id", 0);
      if (this.type == 1) {
        fd.append("type", 1);
      }
      httpUpload(fd).then((res) => {
        this.$message.success(res.data.msg);
        this.formData.uploadTableData.push({
          upload_name: res.data.data.upload_name,
          url: res.data.data.upload_url,
          size: res.data.data.size,
          id: res.data.data.id,
          fileType: res.data.data.fileType,
        });
      });
    },
    // 删除一行：仅为前端删除，未调后台接口
    deleteFile(row) {
      let that = this;
      // console.log(row.id);
      this.formData.uploadTableData.forEach((item, index) => {
        // console.log(item);
        if (item.id == row.id) {
          that.formData.uploadTableData.splice(index, 1);
          that.delFile(row.id);
        }
      });
      // console.log(this.formData.uploadTableData);
    },
    // 删除附件
    delFile(id) {
      let data = {
        id: id,
      };
      httpUploadDe(data).then((res) => {
        this.$message.success(res.msg);
      });
      // this.$http
      //   .post("adminapi/applyform/applyform/upload-de", { id: id })
      //   .then((res) => {
      //     this.$message.success(res.msg);
      //   })
      //   .catch((err) => {});
    },
    //预览word，pdf
    preview({ url, fileType, size }) {
      if (size <= 0) {
        // alert("no");
        this.$message("文件大小为0，无法打开，请重新上传");
      } else {
        if (fileType == "pdf") {
          window.open(url, "_blank");
          // console.log(url);
        } else {
          // console.log(url);
          window.open(
            "http://view.officeapps.live.com/op/view.aspx?src=" + url,
            "_blank"
          );
        }
      }
    },
    //下载pdf
    downloadPdf(row) {
      // console.log(row);
      this.httpDownloadPdf(row);
    },
    httpDownloadPdf(row) {
      console.log(row.upload_name);
      let data = {
        responseType: "blob",
        name: row.upload_name,
        url: row.url,
      };
      httpDownload(data)
        .then((res) => {})
        .catch((res) => {
          const blob = new Blob([res], {
            type: "application/pdf;charset-UTF-8",
          });
          // console.log(blob);
          const fileName = row.upload_name;
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            // navigator.msSaveBlob(blob, fileName);
            navigator.msSaveBlob(blob);
          }
        });
      // this.$http
      //   .post(
      //     "adminapi/scheduling/scheduling-record-review/download",
      //     {
      //       name: row.upload_name,
      //       url: row.url,
      //     },
      //     { responseType: "blob" }
      //   )
      //   .then((res) => {})
      //   .catch((res) => {
      //     const blob = new Blob([res], {
      //       type: "application/pdf;charset-UTF-8",
      //     });
      //     // console.log(blob);
      //     const fileName = row.upload_name;
      //     if ("download" in document.createElement("a")) {
      //       // 非IE下载
      //       const elink = document.createElement("a");
      //       elink.download = fileName;
      //       elink.style.display = "none";
      //       elink.href = URL.createObjectURL(blob);
      //       document.body.appendChild(elink);
      //       elink.click();
      //       URL.revokeObjectURL(elink.href); // 释放URL 对象
      //       document.body.removeChild(elink);
      //     } else {
      //       // IE10+下载
      //       // navigator.msSaveBlob(blob, fileName);
      //       navigator.msSaveBlob(blob);
      //     }
      //   });
    },
    // 上传弹窗
    uploadApplication() {
      this.uploadShow = true;
    },

    handleClose(done) {
      done();
    },

    //   点击隐藏
    hideContent(index) {
      if (index === "1" && this.hide1 === true) {
        this.hide1 = false;
      } else if (index === "1" && this.hide1 === false) {
        this.hide1 = true;
      }
      if (index === "2" && this.hide2 === true) {
        this.hide2 = false;
      } else if (index === "2" && this.hide2 === false) {
        this.hide2 = true;
      }
      if (index === "3" && this.hide3 === true) {
        this.hide3 = false;
      } else if (index === "3" && this.hide3 === false) {
        this.hide3 = true;
      }
      if (index === "4" && this.hide4 === true) {
        this.hide4 = false;
      } else if (index === "4" && this.hide4 === false) {
        this.hide4 = true;
      }
      if (index === "5" && this.hide5 === true) {
        this.hide5 = false;
      } else if (index === "5" && this.hide5 === false) {
        this.hide5 = true;
      }
      if (index === "6" && this.hide6 === true) {
        this.hide6 = false;
      } else if (index === "6" && this.hide6 === false) {
        this.hide6 = true;
      }
      if (index === "7" && this.hide7 === true) {
        this.hide7 = false;
      } else if (index === "7" && this.hide7 === false) {
        this.hide7 = true;
      }
      if (index === "8" && this.hide8 === true) {
        this.hide8 = false;
      } else if (index === "8" && this.hide8 === false) {
        this.hide8 = true;
      }
      if (index === "9" && this.hide9 === true) {
        this.hide9 = false;
      } else if (index === "9" && this.hide9 === false) {
        this.hide9 = true;
      }
    },

    projectChange(e, idx) {
      this.$forceUpdate(); //解决select无法选中
    },

    filterChangeProject_number(e) {
      this.select_list_obj.project_number.map((item, index) => {
        if (item.key == e) {
          this.formData.project_number_prefix = item.value;
        }
      });
    },
    goToLastPage() {
      this.$router.go(-1);
    },
    // 上传文件
    fileChange(e, pop) {
      let formDatas = new FormData();
      formDatas.append("file", e.currentTarget.files[0]);
      let data = {
        formDatas,
      };
      httpUploads(data).then((res) => {
        this.formData[pop] = res.data.data[0];
      });
      // this.$http
      //   .post("adminapi/upload/upload/uploads", formDatas)
      //   .then((res) => {
      //     console.log(res);
      //     this.formData[pop] = res.data[0];
      //   });
    },

    // 提交添加
    submit(formName) {
      this.formData.price = this.com_price;
      this.formData.check_id_lists = this.hasdetectionClassLists; //1124
      console.log(this.formData.check_id_lists);

      this.formData.check_id_lists.forEach((item, index) => {
        console.log(item);
        if (!this.$tools.isEmpty(item)) {
          this.formData.check_id_lists.splice(index, 0);
        }
      }); //处理空数组

      let detectionClass = [],
        check_id_arr = [],
        entrustment_Inspection = [];
      this.hasdetectionClassLists.map((item) => {
        detectionClass.push(item.key);
        if (item.children) {
          item.children.map((item1) => {
            console.log(item1.children);
            check_id_arr.push(item1.key);
            if (item1.children) {
              item1.children.map((item3) => {
                entrustment_Inspection.push(item3.key);
              });
            }
          });
        }
      });
      this.formData.check_id[0].detectionClass = detectionClass.join(",");
      this.formData.check_id[0].check_id = check_id_arr.join(",");
      this.formData.check_id[0].entrustment_Inspection =
        entrustment_Inspection.join(",");

      // 多选检测人员  实验分室
      if (!this.$tools.isEmpty(this.formData.audit_uid_list)) {
        this.formData.audit_uid = this.formData.audit_uid_list.join(","); //审核人数组转为字符串
      }
      if (!this.$tools.isEmpty(this.formData.join_uid_list)) {
        this.formData.join_uid = this.formData.join_uid_list.join(",");
      } //会签人
      if (!this.$tools.isEmpty(this.formData.join_cc_uid_list)) {
        this.formData.join_cc_uid = this.formData.join_cc_uid_list.join(",");
      } //抄送人
      if (!this.$tools.isEmpty(this.formData.check_project_leader_id_list)) {
        this.formData.check_project_leader_id =
          this.formData.check_project_leader_id_list.join(","); //项目负责人数组转为字符串
      }
      // 多少个工作日
      this.formData.check_cycle = this.cup_check_cycle;

      let that = this;

      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formData.audit_status = ""; //清除来自其他详情的审核状态，防止询价单-填写申请单后无需审核即在申请列表显示

          // 获取项目负责人名字
          this.formData.check_project_leader_id_list.forEach((item) => {
            that.select_list_obj.users.forEach((item2) => {
              if (item == item2.key) {
                that.formData.check_project_leader_name_list.push(item2.value);
                that.formData.check_project_leader_name =
                  that.formData.check_project_leader_name_list.join(",");
              }
            });
          });
          let new_formData = {},
            url = "";
          // 来自询价单
          if (this.$route.query.isInquiry) {
            url = "adminapi/applyform/applyform/add";
            new_formData = {
              ...this.formData,
              id: "",
              inquiry_id: this.$route.query.inquiry_id,
            };
          } else {
            url = "adminapi/applyform/applyform/add";
            // new_formData = this.formData;
            new_formData = {
              ...this.formData,
              offer_id:
                this.$route.query.come == "applicationForm" &&
                this.$route.query.from == "applicationForm"
                  ? ""
                  : this.$route.query.id,
              customer_id:
                this.$route.query.come == "applicationForm" &&
                this.$route.query.from == "Offer"
                  ? this.$route.query.customer_id
                  : this.$route.query.id,
            };
          }
          let data = {
            new_formData,
          };
          httpFormAdd(data)
            .then((res) => {
              // that.$tools.msg(that.$message, 1);
              this.$router.back();
              that.loading = false;
              this.$message({
                type: "success",
                message: "新增成功!777",
              });
            })
            .catch((err) => {
              that.loading = false;
            });

          // this.$http
          //   .post("adminapi/applyform/applyform/add", new_formData)
          //   .then((res) => {
          //     that.$tools.msg(that.$message, 1);
          //     // this.$router.back();
          //     this.$router.push("/CustomerManagement");
          //     that.loading = false;
          //   })
          //   .catch((err) => {
          //     that.loading = false;
          //   });
        } else {
          that.loading = false;
          return false;
        }
      });
    },
    handleGoto(path) {
      this.$router.push({
        path: path,
      });
    },
    filterChange() {},

    // 获取对应城市,省变化，即清空市区
    changeProvince(e, v, type) {
      this.formData[`${type}_city`] = "";
      this.formData[`${type}_address`] = "";
      this.getCity(e, v, type);
      // console.log(this.formData[`${type}_province`]);
    },
    // 市变化，则区清空
    changeCity(e, type) {
      this.formData[`${type}_address`] = "";
    },
    // 企业库
    handleEnterprise(e, enterprise_key, enterprise_type, enterprise_val) {
      // this.isEnterpriseLibrary = true;
      this.enterprise_key = enterprise_key;
      this.enterprise_type = enterprise_type;
      this.enterprise_val = enterprise_val;
      // 999
      var pattern3 = new RegExp("[0-9]+");
      if (pattern3.test(e)) {
        this.hide(e);
      } else {
        this.formData[this.enterprise_type + this.enterprise_val + "_name"] = e;
        console.log(
          this.formData[this.enterprise_type + this.enterprise_val + "_name"],
          e
        );
      }
    },
    async hide(id) {
      // console.log("hide", id);
      this.enterprise_id = id;
      // console.log("this.enterprise_id", this.enterprise_id);
      this.isEnterpriseLibrary = false;
      if (id) {
        //有选择操作
        let res,
          obj = {};
        let data = {
          page: 1,
          limit: 1,
          id: this.enterprise_id,
        };
        res = httpEnterpriseList(data).then((res) => {
          obj = res.data.data.list[0]; //获取到从企业库选择的数据
          this.formData.enterprise_client_address = obj.registered_address;
          this.formData.enterprise_client_contacts = obj.username;
          this.formData.enterprise_client_phone = obj.phone;
        });
        obj = res.data.list[0]; //获取到从企业库选择的数据
        // res = await this.$http.post("adminapi/enterprise/enterprise/list", {
        //   page: 1,
        //   limit: 1,
        //   id: this.enterprise_id,
        // });
        // // console.log("请求该id结果", res.data);
        // obj = res.data.list[0]; //获取到从企业库选择的数据

        // 赋值当前页面
        let pop,
          name,
          province,
          city,
          address,
          id,
          phone,
          tel,
          contacts,
          postcode,
          code,
          email;
        id = this.enterprise_type + this.enterprise_val + "_id";
        name = this.enterprise_type + this.enterprise_val + "_name";
        province = this.enterprise_type + this.enterprise_val + "_province";
        city = this.enterprise_type + this.enterprise_val + "_city";
        address = this.enterprise_type + this.enterprise_val + "_address";
        phone = this.enterprise_type + this.enterprise_val + "_phone";
        tel = this.enterprise_type + this.enterprise_val + "_tel";
        contacts = this.enterprise_type + this.enterprise_val + "_contacts";
        postcode = this.enterprise_type + this.enterprise_val + "_postcode";
        code = this.enterprise_type + this.enterprise_val + "_code";
        email = this.enterprise_type + this.enterprise_val + "_email";

        this.formData[id] = this.enterprise_id;
        this.formData[name] = obj.enterprise_name;
        this.formData[province] = obj.registered_province; //省id
        this.formData[city] = obj.registered_city;
        this.formData[address] = obj.registered_address_dizhi;
        this.formData[phone] = obj.phone;
        this.formData[tel] = obj.contact_tel;
        this.formData[contacts] = obj.contacts;
        this.formData[postcode] = obj.postcode;
        this.formData[code] = obj.organization_code;
        this.formData[email] = obj.e_mail;
        // 获取市
        this.getCity(obj.registered_province, this.enterprise_key); //省id  赋值list所需id
      }
    },
    // 复选框
    checkbox_change(e) {
      // console.log(e);
      if (e.length >= 2) {
        this.formData.oenterprise_make_form = e.join(",");
      } else {
        this.formData.oenterprise_make_form = e[0];
      }
    },
    // 资质标识专用章
    specialSeal_change(e) {
      if (e.length >= 2) {
        this.formData.check_special_seal = e.join(",");
      } else {
        this.formData.check_special_seal = e[0];
      }
    },
    elchange(e) {
      // console.log(e)
    },
    // 同上
    ditto(val, key, num) {
      console.log();
      // console.log(val, key, num);
      let pop,
        name,
        province,
        city,
        address,
        id,
        phone,
        tel,
        contacts,
        postcode,
        email,
        code;
      pop = "city_list_" + String(key);

      if (num == "1") {
        this.select_list_obj[pop] = this.select_list_obj.city_list_1;
        name = "enterprise_" + val + "_name";
        province = "enterprise_" + val + "_province";
        city = "enterprise_" + val + "_city";
        address = "enterprise_" + val + "_address";
        id = "enterprise_" + val + "_id";
        phone = "enterprise_" + val + "_phone";
        tel = "enterprise_" + val + "_tel";
        contacts = "enterprise_" + val + "_contacts";
        postcode = "enterprise_" + val + "_postcode";
        email = "enterprise_" + val + "_email";
        code = "enterprise_" + val + "_code";
        this.formData[id] = this.enterprise_id;
        this.formData[name] = this.formData.enterprise_client_name;
        this.formData[province] = this.formData.enterprise_client_province;
        this.formData[city] = this.formData.enterprise_client_city;
        this.formData[address] = this.formData.enterprise_client_address;
        this.formData[phone] = this.formData.enterprise_client_phone;
        this.formData[tel] = this.formData.enterprise_client_tel;
        this.formData[contacts] = this.formData.enterprise_client_contacts;
        this.formData[postcode] = this.formData.enterprise_client_postcode;
        this.formData[code] = this.formData.enterprise_client_code;
        this.formData[email] = this.formData.enterprise_client_email;
      } else {
        this.select_list_obj[pop] = this.select_list_obj.city_list_5;
        name = "oenterprise_" + val + "_name";
        province = "oenterprise_" + val + "_province";
        city = "oenterprise_" + val + "_city";
        address = "oenterprise_" + val + "_address";
        id = "oenterprise_" + val + "_id";
        phone = "oenterprise_" + val + "_phone";
        tel = "oenterprise_" + val + "_tel";
        contacts = "oenterprise_" + val + "_contacts";
        postcode = "oenterprise_" + val + "_postcode";
        code = "oenterprise_" + val + "_code";
        email = "oenterprise_" + val + "_email";
        this.formData[id] = this.enterprise_id;
        this.formData[name] = this.formData.oenterprise_pay_name;
        this.formData[province] = this.formData.oenterprise_pay_province;
        this.formData[city] = this.formData.oenterprise_pay_city;
        this.formData[address] = this.formData.oenterprise_pay_address;
        this.formData[phone] = this.formData.oenterprise_pay_phone;
        this.formData[tel] = this.formData.oenterprise_pay_tel;
        this.formData[contacts] = this.formData.oenterprise_pay_contacts;
        this.formData[postcode] = this.formData.oenterprise_pay_postcode;
        this.formData[code] = this.formData.oenterprise_pay_code;
        this.formData[email] = this.formData.oenterprise_pay_email;
      }
    },
    // 时间选择器
    handleTime(e) {
      this.formData.check_start_time = e[0];
      this.formData.check_end_time = e[1];
    },
    // 点击级联选择器  产品大类
    handleChange(e) {
      this.select_list_obj.pid = e[e.length - 1];
      this.formData.product_large_class = e.join(",");
      this.getLetter(); //获取产品小类
    },
    // 产品小类
    handleChangeLetter(e) {
      if (!this.formData.product_large_class) {
        return;
      } else {
        this.formData.product_small_class = e.join(",");
      }
    },
    // 获取省
    getArea() {
      let data = {
        pid: "-1",
      };
      httpArea(data).then((res) => {
        console.log(res.data, "第3个接口");
        this.select_list_obj.province_list = res.data.data;
      });
      // this.$http
      //   .post("adminapi/common/area", {
      //     pid: "-1",
      //   })
      //   .then((res) => {
      //     this.select_list_obj.province_list = res.data;
      //   })
      //   .catch((err) => {});
    },
    // 获取区
    getCity(pid, suffix) {
      let data = {
        pid,
      };
      httpArea(data).then((res) => {
        console.log(res.data, "第3个接口");
        let pop = "city_list_" + suffix;
        this.select_list_obj[pop] = res.data.data;
      });
      // this.$http
      //   .post("adminapi/common/area", {
      //     pid,
      //   })
      //   .then((res) => {
      //     let pop = "city_list_" + suffix;
      //     this.select_list_obj[pop] = res.data;
      //   })
      //   .catch((err) => {});
    },
    // 获取产品小类
    getLetter() {
      let data = {
        pid: this.select_list_obj.pid,
      };
      httpClassifySelect(data).then((res) => {
        console.log(res.data, "第5个接口");
        this.select_list_obj.letter_class = res.data.data;
      });

      // this.$http
      //   .post("adminapi/applyform/applyform/classify_select", {
      //     pid: this.select_list_obj.pid,
      //   })
      //   .then((res) => {
      //     this.select_list_obj.letter_class = res.data;
      //   })
      //   .catch((err) => {});
    },
    // 获取产品大类
    getLarge() {
      let data = {
        path_now: 3,
      };
      httpClassifySelect(data).then((res) => {
        console.log(res.data, "第5个接口");
        this.select_list_obj.large_class = res.data.data;
      });
      // this.$http
      //   .post("adminapi/applyform/applyform/classify_select", {
      //     path_now: 3,
      //   })
      //   .then((res) => {
      //     this.select_list_obj.large_class = res.data;
      //   })
      //   .catch((err) => {});
    },
    // 获取下拉
    getStation() {
      let data = {
        org: [7, 6, 5, 4],
      };
      httpApplyformSelect(data).then((res) => {
        console.log(res.data, "第4个接口");
        this.select_list_obj = { ...this.select_list_obj, ...res.data.data };
        this.formData.business_type = this.$route.query.key; //设置业务类型默认值
      });

      // this.$http
      //   .post("adminapi/applyform/applyform/select", { org: [7, 6, 5, 4] })
      //   .then((res) => {
      //     this.select_list_obj = { ...this.select_list_obj, ...res.data };
      //     this.formData.business_type = this.$route.query.key; //设置业务类型默认值
      //   })
      //   .catch((err) => {});
    },
    //获取会签人
    getCountersign() {
      let data = {
        module: "1",
      };
      httpReviewerSelect(data).then((res) => {
        console.log(res.data, "第6个接口");
        this.countersign = res.data.data;
      });

      // this.$http
      //   .post("adminapi/permission/menu/reviewer_select", { module: "1" })
      //   .then((res) => {
      //     this.countersign = res.data;
      //   })
      //   .catch((err) => {});
    },

    getDetail() {
      let data = {
        id: this.$route.query.inquiry_id,
      };
      httpDetails(data).then((res) => {
        this.formData = {
          ...this.formData,
          ...res.data.data,
          id: this.$route.query.inquiry_id,
        };
        this.formData.time = [
          this.formData.check_start_time,
          this.formData.check_end_time,
        ];

        // 多选检测人员  实验分室
        if (!this.$tools.isEmpty(this.formData.audit_uid)) {
          this.formData.audit_uid_list = this.formData.audit_uid.split(",");
        } //审核人回显
        if (!this.$tools.isEmpty(this.formData.join_uid)) {
          this.formData.join_uid_list = this.formData.join_uid.split(",");
        } //会签人
        if (!this.$tools.isEmpty(this.formData.join_cc_uid)) {
          this.formData.join_cc_uid_list = this.formData.join_cc_uid.split(",");
        } //抄送人
        if (!this.$tools.isEmpty(this.formData.check_project_leader_id)) {
          this.formData.check_project_leader_id_list =
            this.formData.check_project_leader_id.split(",");
        } //项目负责人
        if (!this.$tools.isEmpty(this.formData.check_division_id)) {
          this.formData.check_division_id_list =
            this.formData.check_division_id.split(",");
        } //实验分室
        // 复选框
        if (!this.$tools.isEmpty(this.formData.oenterprise_make_form)) {
          this.formData.checkboxvalue =
            this.formData.oenterprise_make_form.split(",");
        }

        // 检测项目回显
        if (!this.$tools.isEmpty(this.formData.check_id)) {
          this.formData.check_id.map((item, index) => {
            if (!this.$tools.isEmpty(item.entrustment_Inspection)) {
              item.entrustment_Inspection_list =
                item.entrustment_Inspection.split(",");
            }
          });
        }

        // 地区计算
        this.com_area();
        // 判断是否拉取 子类数据
        if (this.formData.large_class_arr.length > 0) {
          this.select_list_obj.pid =
            this.formData.large_class_arr[
              this.formData.large_class_arr.length - 1
            ];
          this.getLetter();
        }
      });
      // this.$http
      //   .post("adminapi/applyform/inquiry/details", {
      //     id: this.$route.query.inquiry_id,
      //   })
      //   .then((res) => {

      //   })
      //   .catch((err) => {});
    },
    com_area() {
      let arr_area,
        pop,
        arr,
        temporary = {
          city_list_1: [],
          city_list_2: [],
          city_list_3: [],
          city_list_4: [],
          city_list_5: [],
          city_list_6: [],
          city_list_7: [],
        },
        tempop;
      // arr_area = Lockr.get("area_all");
      arr = [
        this.formData.enterprise_client_city,
        this.formData.enterprise_manufacturer_city,
        this.formData.enterprise_make_city,
        this.formData.enterprise_agent_city,
        this.formData.oenterprise_pay_city,
        this.formData.oenterprise_invoice_city,
        this.formData.oenterprise_receiving_city,
      ];
      arr.map((item, index) => {
        if (item) {
          arr_area.map((ite, idx) => {
            if (item == ite.areaId) {
              tempop = "city_list_" + (index + 1);
              temporary[tempop].push(ite); //临时存储
            }
          });
        }
      });
      this.select_list_obj = { ...this.select_list_obj, ...temporary };
    },

    // 1108
    // 获取检测产品分类下拉
    getCommon() {
      let data = {
        key: "testing_product_classify",
      };
      httpCommonSelect(data).then((res) => {
        console.log(res.data, "第2个接口");
        this.testing_product_classify = res.data.data;
      });

      // this.$http
      //   .post("adminapi/common/select", { key: "testing_product_classify" })
      //   .then((res) => {
      //     this.testing_product_classify = res.data;
      //   })
      //   .catch((err) => {});
    },
    // 11.12
    // 获取检测分类下拉
    getProductSelect(productClass) {
      this.product_title = productClass;
      let data = {
        type: 1,
        product_title: this.product_title,
      };
      httpTextPro(data).then((res) => {
        this.detectionClassList = res.data.data;
        this.formData.check_id[0].detectionClassArr = [];
        this.formData.check_id[0].check_idArr = [];
        this.formData.check_id[0].entrustment_Inspection_list = [];
        this.standartList = [];
        this.testProjectList = [];
        this.hastestProjectList = [];
        this.hastestProjectValue = [];
        this.hasdetectionClassLists = [];
        this.allChecked = false;
      });
      // this.$http
      //   .post("adminapi/common/testproject", {
      //     type: 1,
      //     product_title: this.product_title,
      //   })
      //   .then((res) => {
      //     // console.log(res.data);
      //     this.detectionClassList = res.data;
      //     // 3.4
      //     this.formData.check_id[0].detectionClassArr = [];
      //     this.formData.check_id[0].check_idArr = [];
      //     this.formData.check_id[0].entrustment_Inspection_list = [];
      //     this.standartList = [];
      //     this.testProjectList = [];
      //     this.hastestProjectList = [];
      //     this.hastestProjectValue = [];
      //     this.hasdetectionClassLists = [];
      //     this.allChecked = false;
      //   })
      //   .catch((err) => {});
    },
    // 根据检测分类获取检测标准下拉 检测分类change事件
    getStandardSelect(detectionClassArr) {
      // 清空
      console.log("----------------------------------清空", detectionClassArr);
      this.standartList = [];
      this.testProjectList = [];
      if (
        (this.hasdetectionClassLists != 0 &&
          detectionClassArr.length > this.hasdetectionClassLists.length + 1) ||
        (this.hasdetectionClassLists == 0 && detectionClassArr.length >= 2)
      ) {
        this.$tools.msg(
          this.$message,
          "",
          "请选择至项目后，选择其他项目",
          "warning"
        );

        this.formData.check_id[0].detectionClassArr.map((ite, idx) => {
          if (ite == detectionClassArr[detectionClassArr.length - 1]) {
            this.formData.check_id[0].detectionClassArr.splice(idx, 1);
          }
        });

        return;
      }
      let detLength = detectionClassArr.length;
      this.category_title = detectionClassArr[detLength - 1];
      if (!this.category_title) {
        this.standartList = [];
        this.testProjectList = [];
        return;
      }
      let data = {
        type: 1,
        product_title: this.product_title,
        category_title: this.category_title,
      };
      httpTextPro(data).then((res) => {
        this.standartList = res.data.data;
      });

      // this.$http
      //   .post("adminapi/common/testproject", {
      //     type: 1,
      //     product_title: this.product_title,
      //     category_title: this.category_title,
      //   })
      //   .then((res) => {
      //     this.standartList = res.data;

      //     console.log("this.standartList", this.standartList);
      //   })
      //   .catch((err) => {});
    },
    // 根据检测标准查找检测项目下拉框 testProjectList
    getTestproject(entrustment_Inspection_list) {
      console.log("entrustment_Inspection_list", entrustment_Inspection_list);
      let detLength = entrustment_Inspection_list.length;
      this.standard_title = entrustment_Inspection_list[detLength - 1];
      if (!this.standard_title) {
        this.testProjectList = [];
        return;
      }
      let data = {
        type: 1,
        product_title: this.product_title,
        category_title: this.category_title,
        standard_title: this.standard_title,
      };
      httpTextPro(data).then((res) => {
        this.testproject = res.data.data; //存起检测项目接口返回元数据
        this.testProjectList = res.data.data;

        let allcheck = 0;
        this.testProjectList.forEach((item) => {
          if (
            this.formData.check_id[0].entrustment_Inspection_list.indexOf(
              item.key
            ) == -1
          ) {
            allcheck = allcheck + 1;
          }
        });

        // console.log(allcheck);

        if (
          allcheck == 0 &&
          this.formData.check_id[0].entrustment_Inspection_list
        ) {
          this.allChecked = true;
        } else {
          this.allChecked = false;
        }
      });

      // this.$http
      //   .post("adminapi/common/testproject", {
      //     type: 1,
      //     product_title: this.product_title,
      //     category_title: this.category_title,
      //     standard_title: this.standard_title,
      //   })
      //   .then((res) => {
      //     this.testproject = res.data; //存起检测项目接口返回元数据
      //     this.testProjectList = res.data;
      //     console.log("this.testProjectList", this.testProjectList);

      //     let allcheck = 0;
      //     this.testProjectList.forEach((item) => {
      //       if (
      //         this.formData.check_id[0].entrustment_Inspection_list.indexOf(
      //           item.key
      //         ) == -1
      //       ) {
      //         allcheck = allcheck + 1;
      //       }
      //     });

      //     // console.log(allcheck);

      //     if (
      //       allcheck == 0 &&
      //       this.formData.check_id[0].entrustment_Inspection_list
      //     ) {
      //       this.allChecked = true;
      //     } else {
      //       this.allChecked = false;
      //     }
      //   })
      //   .catch((err) => {});
    },
    // hastestProjectList
    entrustment_Inspection_listChange(entrustment_Inspection_list) {},
    // 3.4
    entrustment_Inspection_AloneChange(en_item) {
      let isHas = false,
        has_length = 0;
      if (!this.$tools.isEmpty(this.hasdetectionClassLists)) {
        this.hasdetectionClassLists.map((item, index) => {
          if (item.key == en_item.key) {
            // 已经有这条数据  删除
            this.hasdetectionClassLists.splice(index, 1);
            isHas = true;
            this.testProjectList.map((ite) => {
              if (item.key == ite.key) {
                has_length++;
              }
            });
            if (
              this.$tools.isEmpty(this.hasdetectionClassLists) ||
              has_length !=
                this.formData.check_id[0].entrustment_Inspection_list.length
            ) {
              this.allChecked = false;
            }
          }
        });
        // 不包含本条数据
        if (!isHas) {
          this.hasdetectionClassLists.push(en_item);
          this.testProjectList.map((item, index) => {
            this.hasdetectionClassLists.map((ite, idx) => {
              if (item.key == ite.key) {
                has_length++;
              }
            });
          });
          // console.log('不包含本条数据',has_length,this.formData.check_id[0].entrustment_Inspection_list.length)
          if (has_length == this.testProjectList.length) {
            this.allChecked = true;
          } else {
            this.allChecked = false;
          }
        }
      } else {
        this.hasdetectionClassLists.push(en_item);
        this.testProjectList.map((item, index) => {
          this.hasdetectionClassLists.map((ite, idx) => {
            if (item.key == ite.key) {
              has_length++;
            }
          });
        });
        if (has_length == this.testProjectList.length) {
          this.allChecked = true;
        } else {
          this.allChecked = false;
        }
      }
    },
    // 11.12
    handleAll(e) {
      // 选中
      if (e) {
        this.allChecked = true;

        let isHas = false;
        this.testProjectList.map((item, index) => {
          this.formData.check_id[0].entrustment_Inspection_list.push(item.key);

          if (!this.$tools.isEmpty(this.hasdetectionClassLists)) {
            this.hasdetectionClassLists.map((ite, index) => {
              if (ite.key == item.key) {
                isHas = true;
              }
            });
            if (!isHas) {
              this.hasdetectionClassLists.push(item);
            }
          } else {
            this.hasdetectionClassLists.push(item);
          }
        });
      } else {
        // 取消选中
        this.allChecked = false;
        this.formData.check_id[0].entrustment_Inspection_list = [];
        this.testProjectList.map((item, index) => {
          this.hasdetectionClassLists.map((ite, idx) => {
            if (item.key == ite.key) {
              this.hasdetectionClassLists.splice(idx, 1);
            }
          });
        });
      }
    },
    // 11.12
    // 已选项目删除分类
    handleDel(idx) {
      this.hasdetectionClassLists.splice(idx, 1);
    },

    // 获取企业库数据
    getenterprise() {
      let data = {
        limit: 10000,
      };
      httpEnterpriseList(data).then((res) => {
        console.log(res.data, "第一个接口");
        this.enterprise_select = res.data.data.list;
      });
      // this.$http
      //   .post("adminapi/enterprise/enterprise/list", {
      //     limit: 10000,
      //   })
      //   .then((res) => {
      //     this.enterprise_select = res.data.list;
      //   })
      //   .catch((err) => {});
    },
  },
  created() {
    this.getenterprise();
    this.getCommon(); // 获取检测产品分类下拉
    this.getArea();
    this.getStation();
    this.getLarge();
    this.getCountersign();
    if (this.$route.query.isInquiry) {
      this.getDetail();
    }

    this.come = this.$route.query.come; //控制申请单和下单页面区别
  },
};
</script>

<style lang="scss" scoped>
.ApplicationFormFillIn {
  .title {
    font-size: 32px;
    color: #333333;
    margin: 20px 0;
    font-weight: 600;
    text-align: center;
  }
}
.base_card {
  background: #f5f5f5;
  margin: 20px 0;
  .base_card_title {
    height: 46px;
    line-height: 46px;
    font-size: 20px;
    background: #62b3ff;
    color: #fff;
    padding-left: 15px;
    margin-bottom: 20px;
  }
  .add_attachment {
    width: 100px;
    height: 32px;
    line-height: 32px;
    background: #f2f2f2;
    border: 1px solid #999999;
    color: #999999;
    border-radius: 2px;
    text-align: center;
    z-index: -1;
  }
}
// 所有输入框宽度，需调整企业库输入框宽度、实验时间宽度、检测周期宽度
/deep/.el-form {
  .input,
  .el_ipt,
  .el-date-picker {
    // width: 460px;
    width: 60%;
  }
  // .mini_ipt {
  //   // width: 200px;
  //   width: 100%;
  //   margin: 0 20px;
  // }
  .myinput {
    width: 80%;
  }
}
// 检测的表单宽度
/deep/.testing {
  .input,
  .el_ipt,
  .el-date-picker {
    width: 80%;
    margin-left: 0;
  }
  .mini_ipt {
    // width: 200px;
    width: 10%;
    margin: 0 6px;
    .el-input__inner {
      padding: 0 4px;
    }
  }
  // 标签宽度
  .el-form-item__label {
    width: 130px;
  }
  // 输入框左边距
  .el-form-item__content {
    margin-left: 130px;
  }

  // 检测周期
  .timerSelect {
    width: 60%;
    .el-range-separator {
      width: 24px;
    }
  }
}
.fill_item {
  .el-select {
    width: 60% !important;
    margin-right: 10px;
  }
}
.bottom_btn {
  padding: auto 18px;
  background: #f2f2f2;
  border: 1px solid #999999;
  border-radius: 2px;
  font-size: 16px;
  color: #333333;
  text-align: center;
  margin: 20px 7px 60px 7px;
}
// 材料清单表格样式
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 18px;
  color: #999999;
  margin: 0 3px;
}

.mytable {
  position: relative;
  .addicon {
    position: absolute;
    top: 26px;
    right: 20px;
    color: #fff;
  }
}
// 特性复选框样式
.texing {
  width: 100%;
  .el-form-item {
    margin: 10px;
    width: 100%;
  }
}
// 食品特性信息
// 体积表面积
/deep/.ml_input {
  width: 60px;
  .el-input__inner {
    padding: 0 0 0 5px !important;
    height: 20px;
    text-align: center;
    border: none;
    border-bottom: 1px solid #606266;
    border-radius: 0;
    background-color: #f5f5f5;
  }
}
// 其他说明
/deep/.other_input {
  width: 120px;
  .el-input__inner {
    padding: 0 0 0 5px !important;
    height: 20px;
    border: none;
    border-bottom: 1px solid #606266;
    border-radius: 0;
    background-color: #f5f5f5;
  }
}
// 说明承诺
.tips1 {
  span {
    color: #62b3ff;
  }
  padding: 10px 30px 10px 40px;
  line-height: 24px;
}

// 1105
// 检测要求或说明的复选框
.checkbox_group {
  display: flex;
  flex-flow: column;
}
// 溢出滚动
/deep/.overflow_scroll_box {
  height: 246px;
  overflow-y: auto;
}
.border_x {
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.border_r {
  border-right: 1px solid #ccc;
}
.border_l {
  border-left: 1px solid #ccc;
}
.padding_10 {
  padding-left: 10px;
}

/deep/.el-radio {
  line-height: 2.5;
}

// 文件回显 附件回显
.filefooter {
  margin-top: 30px;
  // padding-bottom: 50px;
  .image {
    display: flex;
    margin-top: 20px;
    flex-wrap: wrap;
    .image_pdf {
      width: 120px;
      margin-right: 16px;
      .image_pdf_top {
        position: relative;
        width: 120px;
        height: 120px;
        border: 1px solid #999999;
        border-radius: 10px;
        margin-right: 20px;
        text-align: center;
        img {
          margin-top: 10px;
        }
        .box {
          width: 100%;
          height: 34px;
          line-height: 40px;
          background: #666;
          border-radius: 0px 0px 10px 10px;
          position: absolute;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-around;
          i {
            color: #fff;
            font-size: 20px;
          }
        }
      }
      .text {
        width: 120px;
        line-height: 20px;
        margin-top: 5px;
        font-size: 12px;
        // margin-top: 50px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .select {
        /deep/ .el-checkbox__inner {
          border-radius: 8px;
        }
        /deep/ .el-checkbox__inner::after {
          box-sizing: content-box;
          content: "";
          height: 8px;
          width: 8px;
          border-radius: 4px;
          left: 2px;
          position: absolute;
          top: 3px;
          transform: scaleY(0);
          transition: transform 0.15s ease-in 0.05s;
          transform-origin: center;
          background-color: #fff;
          border: none;
        }
        /deep/ .el-checkbox__input.is-checked .el-checkbox__inner::after {
          transform: scaleY(1);
        }
      }
    }
  }
}
// 文件附件添加-弹窗样式
/deep/.el-dialog__body {
  width: 100%;
  .el-upload {
    width: 100%;
  }
  .el-upload-dragger {
    width: 100%;
  }
}

// 3.28
/deep/.el-input.is-disabled .el-input__inner {
  background-color: transparent;
  border-color: transparent;
  color: #606266;
}
.QuotationAccountingSheet {
  // width: 1400px;
  width: 90%;
  margin: 0 auto;
  span {
    color: red;
  }
  &__el-form-box {
    .el-form-item {
      margin-bottom: 0;
    }
    .el-form-item__error {
      top: 50%;
      left: 250px;
      transform: translateY(-50%);
    }
  }
}
// -----------------------------------------------etable
// 表格边框
.etable {
  border: 1px solid #999999;
  width: 100%;
}
.etable tr {
  border: 1px solid #999999;
  height: 60px;
}
.etable tr:nth-last-child() {
  border: none;
}
.etable td {
  border: 1px solid #999999;
  padding: 0 0 0 10px;
}
.etable td:nth-last-child() {
  border: none;
}
// 奇偶宽度
.etable td:nth-child(even) {
  border: 1px solid #999999;
  width: 500px;
}
.etable td:nth-child(odd) {
  border: 1px solid #999999;
  width: 300px;
}
// -----------------------------------------------btable
.btable {
  border: 1px solid #999999;
  // width: 1400px;
  // width: 90%;
  margin: 0 auto;
  margin-top: 40px;
}
.btable > div {
  border-bottom: 1px solid #999999;
  height: 60px;
  position: relative;
}
.btable > div div {
  // width: 255px;
  width: 80%;
  text-align: center;
}
// 报价费用签章部分
.btable > div div.signature > div {
  width: 300px;
  margin: 12px;
  text-align: left;
}
.btable > div div.myreturn {
  width: 100%;
  text-align: left;
}

.btable > div i {
  height: 60px;
  width: 30px;
  line-height: 60px;
  text-align: center;
  position: absolute;
  top: 0px;
  right: 30px;
}
.btable_title {
  font-size: 20px;
  text-align: center;
  line-height: 60px;
}
// -----------------------------------------------ctable
.ctable {
  border: 1px solid #999999;
  // width: 1400px;
  width: 100%;
}
// 奇偶宽度
.fill_in div:nth-child(even) {
  border-bottom: 1px solid #999999;
  height: 60px;
  line-height: 60px;
  box-sizing: border-box;
  // padding-left: 10px;
}
.fill_in div:nth-child(odd) {
  border-top: 1px solid #999999;
  height: 30px;
  line-height: 30px;
  box-sizing: border-box;
  padding-left: 10px;
}
.explain {
  // border-bottom: 1px solid #999999;
  padding-left: 10px;
  .explain_table {
    border: 1px solid #999999;
  }
  .explain_table tr {
    border: 1px solid #999999;
    height: 40px;
  }
  .explain_table tr:nth-last-child() {
    border: none;
  }
  .explain_table td {
    border: 1px solid #999999;
    padding: 0 50px 0 10px;
  }
  .explain_table td:nth-last-child() {
    border: none;
  }
}
.title {
  font-weight: bold;
  line-height: 34px;
  margin: 16px 0 6px 0;
}
.thanks {
  color: #ffc002;
  text-indent: 2em;
  font-size: 16px;
  margin: 12px 0 4px 0;
}
.baojiadanImg {
  width: 100%;
  margin-bottom: 50px;
  text-align: center;
}
.chooseBtn {
  color: #1835e3 !important;
  margin-left: 10px;
  cursor: pointer;
}
</style>
<style lang="scss" scope>
.ipt_item input.el-input__inner {
  border: none;
}
.QuotationAccountingSheet .el-input input {
  width: 80%;
  border: none;
  border-radius: 0;
}

.show_border {
  border: 1px solid #999;
}
.el-form-item__content {
  margin: 0;
}
</style>